export const injectCustomCSSLink = (link: string): (() => void) => {
    if (!link.trim()) {
        return () => {};
    }

    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = link.trim();

    const existingStylesheets = document.head.querySelectorAll<HTMLLinkElement>('link[rel~="stylesheet"]');
    if (Array.from(existingStylesheets).some((existing) => existing.href === stylesheet.href)) {
        return () => {};
    }

    document.head.appendChild(stylesheet);
    return () => stylesheet.remove();
};
